// extracted by mini-css-extract-plugin
export default {"snack":"snackbar_snack__5cdv1"};